// extracted by mini-css-extract-plugin
module.exports = {"marker":"styles_marker__90NML","head":"styles_head__ftnAK","stick":"styles_stick__GzVoe","shadow":"styles_shadow__6H_LO","hover":"styles_hover__4AM9d"};